import { Branch, Brand } from "../../../interfaces/types";

export interface Catalogue {
  branch: Branch;
  link: string;
}

export interface BrandMenuObject {
  name: Brand,
  title: string;
  tags?: string[];
  catalogueList?: Catalogue[]
}

export const allBrands: BrandMenuObject[] = [
  {
    name: "direct-group",
    title: "Direct Group",
  },
  {
    name: "hve",
    title: "High Vis Everywhere",
  },
  {
    name: "biz-collection",
    title: "Biz Collection",
    tags: [
      "polos",
      "tees",
      "shirts",
      "biz separates",
      "knitwear",
      "hoodies-fleece",
      "activewear",
      "jackets",
      "hospitality",
      "health",
      "clearance",
      "catalogue",
    ],
  },
  {
    name: "biz-corporates",
    title: "Biz Corporates",
    tags: [
      "tops",
      "shirts",
      "jackets",
      "vests",
      "pants",
      "skirts",
      "dresses",
      "culottes",
      "shorts",
      "knitwear",
      "outerwear",
      "blouses",
      "advatex",
      "coats",
      "accessories",
      "comfort wool stretch",
      "cool stretch plain",
      "rococo",
      "boulevard",
      "siena suiting",
      "fabric packs",
      "clearance",
    ],
  },
  {
    name: "syzmik",
    title: "Syzmik",
    tags: [
      "polos",
      "tees",
      "shirts",
      "pants",
      "shorts",
      "fleece-hoodies",
      "jackets",
      "vests",
      "overalls",
      "fire-armour",
      "clearance",
      "catalogue",
      "accessories",
    ],
  },
  {
    name: "biz-care",
    title: "Biz Care",
    tags: [
      "polos",
      "tops",
      "shirts",
      "tunics",
      "pants",
      "shorts",
      "skirts",
      "scrubs",
      "knitwear",
      "vests",
      "fleece",
      "jackets",
      "cardigans",
      "T-Tops",
      "pink products",
      "accessories",
      "clearance",
    ],
  },
];

export const transformName = (name: string) => {
  switch (name) {
    case "hoodies-fleece":
      return "Hoodies & Fleece";
    case "fleece-hoodies":
      return "Hoodies & Fleece";
    case "health":
      return "Health and Beauty";
    case "fire-armour":
      return "Fire Armour";
    default:
      return name;
  }
};
